import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosMundialTurismo = {
    ...dadosAgenciaComum,
    id: 'mundialturismo',
    nome: 'Mundial Turismo',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-WSZT4K3']
};
